export default "__VITE_ASSET__BHjQA8Kk__"